import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { WorkerFileVerificationComponent } from './worker-file-verification.component';
import { WorkerFileVerificationRoutingModule } from './worker-file-verification-routing.module';

@NgModule({
  declarations: [
    WorkerFileVerificationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    WorkerFileVerificationRoutingModule,
  ],
})
export class WorkerFileVerificationModule {}
